// ** React Imports
import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography'
import Icon from 'src/features/common/CustomIcon'
import Link from '@mui/material/Link';
// ** Store Imports
import { SelectOption } from 'src/types/common';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
// ** Custom Components Imports
import Tooltip from '@mui/material/Tooltip'
import { client } from 'src/utils/axios-client'
import { leadEndpoints } from 'src/configs/endpoints'

import _ from 'lodash'
import CardContent from '@mui/material/CardContent'
import Skeleton from '@mui/material/Skeleton'

import { XYPlot, LineSeries, VerticalGridLines, HorizontalGridLines, XAxis, YAxis, VerticalBarSeries, MarkSeries, DiscreteColorLegend, ChartLabel, RadialChart } from 'react-vis';
import { curveCatmullRom } from 'd3-shape';
import Chip from '@mui/material/Chip';
import { ResponsivePie, ResponsivePieCanvas } from '@nivo/pie'

type Props = {
    userId: string
}

type Point = {
    value: number,
    id: string,
    label: string,
    color: string
}


const DashboardActivityDonut = ({ userId }: Props) => {
    const [reloadRecords, setReloadRecords] = useState<boolean>(false)
    const [dataLoaded, setDataLoaded] = useState<boolean>(false) 
    const [activityData, setActivityData] = useState<Point[]>([])
    const [miCount, setMiCount] = useState<number>(0)
    const [mqlCount, setMqlCount] = useState<number>(0)
    const [dcCount, setDcCount] = useState<number>(0)
    const [activityCount, setActivityCount] = useState<number>(0)
    const [oppCount, setOppCount] = useState<number>(0)
    
    useEffect(() => {
        loadRecords(userId);
    }, [reloadRecords, userId])

    const loadRecords = async (userId: string) => {
        const response = await client.get(leadEndpoints.getdashboardactivitydonut, { params: { userId } });
        setActivityData(response.data.activities);
        setMiCount(response.data.miCount)
        setMqlCount(response.data.mqlCount)
        setDcCount(response.data.dcCount)
        setActivityCount(response.data.activityCount)
        setOppCount(response.data.oppCount)
        setDataLoaded(true);
       
    }
    

    if (dataLoaded) {
        return (
            <Box >
                <Card sx={{ display: 'flex', ml: 3.0 }}>
                    <Grid item xs={12} md={12}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Card>
                                <Typography sx={{ fontSize: 16, color: 'DarkGrey', ml: 3 }}>
                                    Activity Snapshot - This Month
                                </Typography>

                            </Card>
                        </Box>
                    </Grid>
                </Card>
                <Card sx={{ display: 'flex', ml: 3.0, mt: 2.0, pb: 4 }} >
                    <Grid container spacing={2} justifyContent={'center'} sx={{ ml: 3.0}}>
                        {/*<Grid item xs={12} md={12} alignContent="center" justifyContent={'center'}>*/}
                        {/*    <Grid container spacing={2} sx={{ mt: 4}} >*/}
                        {/*        <Grid item xs={12} md={12} alignContent="center">*/}
                        {/*            <Tooltip title="Activities that had no meaningful interaction" >*/}
                        {/*                <Chip label={activityCount + " Activities"} size="small" sx={{ color: 'Gray' }} />*/}
                        {/*            </Tooltip>*/}
                        {/*            <Tooltip title="Activities that had a meaningful interaction" >*/}
                        {/*                <Chip label={miCount + " MIs"} size="small" sx={{ color: 'Blue' }} />*/}
                        {/*            </Tooltip>*/}
                        {/*            <Tooltip title="Activities that had an MQL" >*/}
                        {/*                <Chip label={mqlCount + " MQLs"} size="small" sx={{ color: 'Orange' }} />*/}
                        {/*            </Tooltip>*/}
                        {/*            <Tooltip title="Activities that had an Discovery Call" >*/}
                        {/*                <Chip label={dcCount + " DCs"} size="small" sx={{ color: 'Green' }} />*/}
                        {/*            </Tooltip>*/}
                                    
                                    
                                    
                                    
                        {/*        </Grid>*/}
                        {/*    </Grid>*/}
                        {/*</Grid>*/}
                        <Grid item xs={12} md={12} alignItems="flex-start">
                            {/*<RadialChart*/}
                            {/*    data={activityData}*/}
                            {/*    width={300}*/}
                            {/*    height={300}*/}
                            {/*    innerRadius={50}*/}
                            {/*    radius={80}*/}
                            {/*    showLabels={false}*/}
                            {/*    colorType="literal"*/}
                            {/*    animation={true}*/}
                            {/*/>*/}
                        </Grid>
                        <Grid item xs={12} md={12} alignItems="flex-start" >
                            <div style={{ height: 250, width: 250 }}>
                                <ResponsivePie
                                    data={activityData}
                                    margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                                    innerRadius={0.5}
                                    padAngle={0.7}
                                    cornerRadius={3}
                                    activeOuterRadiusOffset={8}
                                    colors={{ scheme: 'dark2' }}
                                    borderWidth={1}
                                    borderColor={{
                                        from: 'color',
                                        modifiers: [
                                            [
                                                'darker',
                                                0.2
                                            ]
                                        ]
                                    }}
                                    enableArcLinkLabels={false}
                                    arcLinkLabelsSkipAngle={10}
                                    arcLinkLabelsTextColor="#5b398e"
                                    arcLinkLabelsThickness={2}
                                    arcLinkLabelsColor="#162c83"
                                    arcLabelsRadiusOffset={0.55}
                                    arcLabelsSkipAngle={7}
                                    tooltip={({ datum: { id, value, color } }) => (
                                        <div
                                            style={{
                                                padding: 12,
                                                color,
                                                background: '#222222',
                                            }}
                                        >
                                            <strong>
                                                {id}: {value}
                                            </strong>
                                        </div>
                                    )}

                                    arcLabelsTextColor={{
                                        from: 'color',
                                        modifiers: [
                                            [
                                                'darker',
                                                2
                                            ]
                                        ]
                                    }}
                                    //legends={[
                                    //    {
                                    //        anchor: 'right',
                                    //        direction: 'column',
                                    //        justify: true,
                                    //        translateX: 0,
                                    //        translateY: 0,
                                    //        itemsSpacing: 0,
                                    //        itemWidth: 80,
                                    //        itemHeight: 18,
                                    //        itemTextColor: '#999',
                                    //        itemDirection: 'left-to-right',
                                    //        itemOpacity: 1,
                                    //        symbolSize: 18,
                                    //        symbolShape: 'circle',
                                    //        effects: [
                                    //            {
                                    //                on: 'hover',
                                    //                style: {
                                    //                    itemTextColor: '#000'
                                    //                }
                                    //            }
                                    //        ]
                                    //    }
                                    //]}
                                />
                            </div>
                        </Grid>
                        
                        
                    </Grid>
                </Card>
            </Box>
        )
    }
    else {
        return <Box>
            <Card variant="outlined">
                <CardContent>
                    <Grid item xs={12} md={12} sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                        <Card >
                            <Skeleton variant="text" sx={{ fontSize: 16, ml: 3, mr: 3 }} width={300} />
                        </Card>
                    </Grid>
                    <Grid container spacing={1} justifyContent={'left'}>
                        <Grid item xs={12} md={12} sx={{ display: 'flex', mb: 0.7, alignItems: 'left' }}>
                            <Skeleton variant="circular" width={200} height={200} />
                        </Grid>

                    </Grid>
                </CardContent>

            </Card>

        </Box>
    }

}

export { DashboardActivityDonut }
export default DashboardActivityDonut
